/* eslint-disable react-hooks/exhaustive-deps */
import React, { forwardRef, useEffect, useRef, useState } from "react";
import MolGrid from "../../../components/Grid/MolGrid";
import { SkillCategoryListGridConfig } from "./SkillCategoryList.Data";
import SwalAlert from "../../../services/swalService/SwalService";
import { useDeleteSkillCategoriesMutation, useGetSkillCategoriesMutation } from "../../../app/services/skillCategoriesAPI";
import ToastService from "../../../services/toastService/ToastService";
import { securityKey } from "../../../data/SecurityKey";
import { hasFunctionalPermission } from "../../../utils/authorizeNavigation/authorizeNavigation";

const SkillCategoryList = forwardRef((props, ref) => {
  //** State */
  const { confirm } = SwalAlert();
  const molGridRef = useRef();
  const [listData, setListData] = useState();
  const [totalRowCount, setTotalRowCount] = useState(0);

  const [getSkillCategories, { isLoading: isListLoading, isSuccess: isListSuccess, data: isListeData },] = useGetSkillCategoriesMutation();
  const [deleteSkillCategories, { isSuccess: isDeleteSkillCategoriesSuccess, data: isDeleteSkillCategoriesData },] = useDeleteSkillCategoriesMutation();

  const hasEditPermission = hasFunctionalPermission(securityKey.EDITSKILL);
  const hasDeletePermission = hasFunctionalPermission(securityKey.DELETESKILL);
  const actionColumn = SkillCategoryListGridConfig.columns.find(column => column.name === "Action");
  
  //** UseEffect */
  useEffect(() => {
    if (hasEditPermission?.isViewOnly === true) {
      actionColumn.defaultAction.allowEdit = true;
    }
    else if (hasEditPermission?.isEditable === true) {
      actionColumn.defaultAction.allowEdit = true;
    }
    else {
      actionColumn.defaultAction.allowEdit = false;
    }
  }, [hasEditPermission, actionColumn?.defaultAction?.allowEdit])

  useEffect(() => {
    if (hasDeletePermission?.hasAccess === true) {
      actionColumn.defaultAction.allowDelete = true;
    }
    else if (hasDeletePermission?.hasAccess === false) {
      actionColumn.defaultAction.allowDelete = false;
    }
  }, [hasDeletePermission, actionColumn?.defaultAction?.allowDelete])
  //** Funcation's */
  const getLists = (pageObject) => {
    getSkillCategories(pageObject);
  };

  //** Handle Changes */
  const handlePageChange = (page) => {
    const request = {
      pagination: { pageNumber: page.pageNumber, pageSize: page.pageSize },
      filters: { searchText: props.search },
    };
    getLists(request);
  };

  //** UseEffect */
  useEffect(() => {
    if (isListSuccess && isListeData) {
      if (isListeData) {
        setListData(isListeData.dataSource);
      }
      if (isListeData.totalRecord > 0 || isListeData.totalRecord === 0) {
        setTotalRowCount(isListeData.totalRecord);
      }
    }
  }, [isListSuccess, isListeData]);

  useEffect(() => {
    if (isDeleteSkillCategoriesSuccess && isDeleteSkillCategoriesData) {
      ToastService.success(isDeleteSkillCategoriesData.errorMessage);
      const currentPageObject = molGridRef.current.getCurrentPageObject();
      const request = {
        pagination: {
          pageNumber: currentPageObject.pageNumber,
          pageSize: currentPageObject.pageSize,
        },
        filters: { searchText: props.search },
      };
      getLists(request);
    }
  }, [isDeleteSkillCategoriesSuccess, isDeleteSkillCategoriesData]);

  useEffect(() => {
    if (molGridRef.current) {
      const currentPageObject = molGridRef.current.getCurrentPageObject();
      const request = {
        pagination: {
          pageNumber: currentPageObject.pageNumber,
          pageSize: currentPageObject.pageSize,
        },
        filters: { searchText: props.search },
      };
      getLists(request);
    }
  }, [props.search]);

  useEffect(() => {
    if (ref) {
      ref.current = {
        refreshGrid: () => {
          if (molGridRef.current) {
            const currentPageObject = molGridRef.current.getCurrentPageObject();
            const request = {
              pagination: {
                pageNumber: currentPageObject.pageNumber,
                pageSize: currentPageObject.pageSize,
              },
              filters: { searchText: props.search },
            };
            getLists(request);
          }
        },
      };
    }
  }, [ref]);

  //** Action Method's */
  const handleEditClick = (data) => {
    if (props.onEdit) {
      props.onEdit(data);
    }
  };

  const handleDeleteClick = (data) => {
    confirm("Delete?", "Are you sure you want to Delete?", "Delete", "Cancel")
      .then((confirmed) => {
        if (confirmed) {
          deleteSkillCategories(data.skillCategoriesId);
        }
      });
  };

  const actionHandler = {
    EDIT: handleEditClick,
    DELETE: handleDeleteClick,
  };

  return (
    <>
      <div className="table-body-scroll">
        <MolGrid
          ref={molGridRef}
          configuration={SkillCategoryListGridConfig}
          dataSource={listData}
          allowPagination={true}
          pagination={{
            totalCount: totalRowCount,
            pageSize: 20,
            currentPage: 1,
          }}
          isLoading={isListLoading}
          onActionChange={actionHandler}
          onPageChange={handlePageChange}
        />
      </div>
    </>
  );
});

export default SkillCategoryList;
